module.exports = __webpack_public_path__ + "18a68da9b6f8ec2c3b60d30795e4aa86.png";